import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { MainDrawer } from '../Admin/CommonComponent/MainDrawer';
import { createOneGuruVersionAPI } from '../../services/whatsNewRoadmapService';

interface AddVersionDrawerProps {
	open: boolean;
	handleClose: () => void;
	onSaved: () => void;
}

export const AddVersionDrawer: React.FC<AddVersionDrawerProps> = ({ open, handleClose, onSaved }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [version, setVersion] = useState('');
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!open) {
			return;
		}
		setVersion('');
	}, [open]);

	const handleCancel = () => {
		setVersion('');
		handleClose();
	};

	const handleSaveClick = async () => {
		const trimmedVersion = version.trim();
		if (!trimmedVersion) {
			return;
		}
		try {
			setSaving(true);
			const response: any = await createOneGuruVersionAPI({ version: trimmedVersion });
			if (response?.data?.isSuccess) {
				enqueueSnackbar(response.data.messageList?.Result || t('versionNameSuccessMsg'), { variant: 'success' });
				setVersion('');
				onSaved();
				handleClose();
			} else {
				enqueueSnackbar(t('someErrorOccurred'), { variant: 'error' });
			}
		} catch (error) {
			enqueueSnackbar(t('someErrorOccurred'), { variant: 'error' });
		} finally {
			setSaving(false);
		}
	};

	return (
		<MainDrawer
			drawerClassName='main-drawer-panel add-update-drawer'
			open={open}
			headerTitle={t('addVersionTitle')}
			showHeaderCloseIcon
			handleDrawerClose={handleCancel}
			handleCancelClick={handleCancel}
			handleSaveClick={handleSaveClick}
			cancelBtnText={t('cancelBtn')}
			saveButtonText={t('saveEntryBtn')}
			isSaveButtonDisabled={!version.trim() || saving}
			loader={saving}
		>
			<Box className='add-update-form'>
				<Box className='form-field'>
					<TextField
						required
						fullWidth
						id='version-name'
						name='version'
						label={t('versionLabel')}
						placeholder={t('versionNamePlaceholder')}
						value={version}
						onChange={(event) => setVersion(event.target.value)}
						InputLabelProps={{ shrink: true }}
					/>
				</Box>
			</Box>
		</MainDrawer>
	);
};
